export const GET_USER_DATA_BEGIN   = 'GET_USER_DATA_BEGIN';
export const GET_USER_DATA_SUCCES   = 'GET_USER_DATA_SUCCES';
export const GET_USER_DATA_FAILURE   = 'GET_USER_DATA_FAILURE';
export const GET_USER_DATA_LOGOUT   = 'GET_USER_DATA_LOGOUT';

export const GET_USER_ME_BEGIN   = 'GET_USER_ME_BEGIN';
export const GET_USER_ME_SUCCES   = 'GET_USER_ME_SUCCES';
export const GET_USER_ME_FAILURE   = 'GET_USER_ME_FAILURE';

export const GET_USER_RIGHT_BEGIN   = 'GET_USER_RIGHT_BEGIN';
export const GET_USER_RIGHT_SUCCES   = 'GET_USER_RIGHT_SUCCES';
export const GET_USER_RIGHT_FAILURE   = 'GET_USER_RIGHT_FAILURE';

export const GET_ADMIN_TENDANT_BEGIN   = 'GET_ADMIN_TENDANT_BEGIN';
export const GET_ADMIN_TENDANT_SUCCES   = 'GET_ADMIN_TENDANT_SUCCES';
export const GET_ADMIN_TENDANT_FAILURE   = 'GET_ADMIN_TENDANT_FAILURE';

export const USER_LOGOUT   = 'USER_LOGOUT';


 
export function getuserdata(token,params) {
  let apiurl = window.apiurl
    return dispatch => {
      
        dispatch(getUserDataBegin());
        return fetch("https://"+apiurl+"/api/User", {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
          },
          body: JSON.stringify(params) 
        })
          .then(handleErrors)
          .then(res => res.json())
          .then(json => {
            dispatch(getUserDataSuccess(json));
            return json;
          })
          .catch(error => dispatch(getUserDataFailure(error)));
      }
  }


  export function getuserme(token) {
    let apiurl = window.apiurl
      return dispatch => {
        
          dispatch(getUserMeBegin());
          return fetch("https://"+apiurl+"/api/User/me", {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token,
            },
          })
            .then(handleErrors)
            .then(res => res.json())
            .then(json => {
              dispatch(getUserMeSuccess(json));
              return json;
            })
            .catch(error => dispatch(getUserMeFailure(error)));
        }
    }


    export function getuserrights(token) {
      let apiurl = window.apiurl
        return dispatch => {
          
            dispatch(getUserRightBegin());
            return fetch("https://"+apiurl+"/api/User/me/rights", {
              method: 'GET',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
              },
            })
              .then(handleErrors)
              .then(res => res.json())
              .then(json => {
                dispatch(getUserRightSuccess(json));
                return json;
              })
              .catch(error => dispatch(getUserRightFailure(error)));
          }
      }

  
      export function getadmintenants(token) {
        let apiurl = window.apiurl
          return dispatch => {
            
              dispatch(getAdminTendantBegin());
              return fetch("https://"+apiurl+"/api/User/me/admintenants", {
                method: 'GET',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token,
                },
              })
                .then(handleErrors)
                .then(res => res.json())
                .then(json => {
                  dispatch(getAdminTendantSuccess(json));
                  return json;
                })
                .catch(error => dispatch(getAdminTendantFailure(error)));
            }
        }

    
    
  
    function handleErrors(response) {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    }


    export const getUserDataBegin = () => ({
        type: GET_USER_DATA_BEGIN
      });

    export const getUserDataLogout = () => ({
        type: GET_USER_DATA_LOGOUT
      }); 
      
    export const getUserDataSuccess = userdata => ({
        type: GET_USER_DATA_SUCCES,
        payload: { userdata }
      });
      
    export const getUserDataFailure = error => ({
        type: GET_USER_DATA_FAILURE,
        payload: { error }
      });


    export const getUserMeBegin = () => ({
        type: GET_USER_ME_BEGIN
      });
   
    export const getUserMeSuccess = userme => ({
        type: GET_USER_ME_SUCCES,
        payload: { userme }
      });
      
    export const getUserMeFailure = error => ({
        type: GET_USER_ME_FAILURE,
        payload: { error }
      });

      export const userLogout = () => ({
        type: USER_LOGOUT,
      });

    
      export const getUserRightBegin = () => ({
        type: GET_USER_RIGHT_BEGIN
      });
   
      export const getUserRightSuccess = userrights => ({
        type: GET_USER_RIGHT_SUCCES,
        payload: { userrights }
      });
      
     export const getUserRightFailure = error => ({
        type: GET_USER_RIGHT_FAILURE,
        payload: { error }
      });



      export const getAdminTendantBegin = () => ({
        type: GET_ADMIN_TENDANT_BEGIN
      });
   
      export const getAdminTendantSuccess = admintenants => ({
        type: GET_ADMIN_TENDANT_SUCCES,
        payload: { admintenants }
      });
      
     export const getAdminTendantFailure = error => ({
        type: GET_ADMIN_TENDANT_FAILURE,
        payload: { error }
      });
     